module.exports = __webpack_public_path__ + "static/img/znsb_img_yjsqz.6277030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/znsb_img_yjsqz.png
// module id = 0XSF
// module chunks = 21